import { createFileRoute, redirect } from '@tanstack/react-router';
import { Permission } from '../../features/auth';
import { CaseCartAssemblyPage } from '../../features/case-cart-assembly';

export const Route = createFileRoute('/_auth/case-cart-assembly')({
  staticData: {
    title: 'pages.caseCartAssembly.title',
    description: 'pages.caseCartAssembly.description',
  },
  beforeLoad: async ({ context }) => {
    const { isAuthenticated, hasPermission, isAdmin } = context.auth;

    if (!isAuthenticated) throw redirect({ to: '/' });
    if (!hasPermission(Permission.CART_BUILDER) && !isAdmin())
      throw redirect({ to: '/403' });
  },
  component: CaseCartAssemblyPage,
});
